document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                speed: 3000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 600,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                /* autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                }, */
                navigation: {
                    nextEl: ".sw-sli-next",
                    prevEl: ".sw-sli-prev",
                },
                pagination: {
                    el: ".pagination-slider",
                    clickable: true,
                }
            });
        });
    }

    let slideFullSlider = document.querySelectorAll('.slide-full-slider');
    if(slideFullSlider){
        slideFullSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

});